import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingCart, ArrowRight } from "lucide-react";
import { useCart } from "../../pages/ShopCart";
import { useI18n } from "../../lib/i18n";

// Barre panier fixe en bas de l'écran (mobile), sur le catalogue et les fiches plats.
export function MobileCartBar() {
  const { count, subtotal } = useCart();
  const { t } = useI18n();
  const { pathname } = useLocation();
  const onShopping = pathname === "/boutique" || pathname.startsWith("/boutique/produit/");
  if (!count || !onShopping) return null;
  return (
    <>
      <div className="h-24 md:hidden" aria-hidden="true" />
      <div
        className="md:hidden fixed bottom-0 inset-x-0 z-40 px-3 pt-3 backdrop-blur-xl border-t"
        style={{ background: "rgba(10,10,10,0.9)", borderColor: "rgba(242,236,228,0.1)", paddingBottom: "max(env(safe-area-inset-bottom), 12px)" }}
        data-testid="mobile-cart-bar"
      >
        <Link
          to="/boutique/panier"
          className="flex items-center justify-between gap-3 w-full py-3.5 px-4 text-[11px] uppercase tracking-[0.16em] font-semibold transition-transform active:scale-[0.98]"
          style={{ background: "#E54D2E", color: "#FFFFFF" }}
          data-testid="mobile-cart-bar-btn"
        >
          <span className="flex items-center gap-2" data-testid="mobile-cart-bar-count">
            <ShoppingCart className="w-4 h-4" />
            {count} {count === 1 ? t("cart.barquette_unit") : t("cart.barquette_plural")}
          </span>
          <span className="flex items-center gap-1.5" data-testid="mobile-cart-bar-total">
            {subtotal.toFixed(2)} CHF · {t("add_to_cart.order")} <ArrowRight className="w-3.5 h-3.5" />
          </span>
        </Link>
      </div>
    </>
  );
}
